import UploadList from './UploadList';
import UploadCreate from './UploadCreate';

export default {
  name: 'upload',
  list: UploadList,
  create: UploadCreate,
};
